import type React from 'react';

export const extractBsdsInputValue = (e: React.FormEvent<HTMLBsdsInputElement>): string => {
  const target = e.target as HTMLBsdsInputElement;
  const raw = (e as React.FormEvent<HTMLBsdsInputElement> & { detail?: { value: string } }).detail?.value
    ?? target?.value
    ?? '';
  return String(raw);
};
